export enum LeadingSidebarTab {
  Page = 'page',
  Component = 'component',
  Style = 'style',
  Menu = 'menu',
  Dialog = 'dialog',
  Setting = 'setting',
}

export enum ComponentPanelTab {
  Data = 'data',
  Design = 'design',
  Action = 'action',
  Behavior = 'behavior',
}
